import axios from "axios";
import { AUTH_LOGOUT_DOMAIN } from "constant/app";
import get from "lodash/get";
import { USER_LOGOUT } from "redux-store/auth";
import { setLoaderStatusAction } from "redux-store/loader";
import { auth } from "store/auth";

function _errorHandler(errorHandler, err) {
  const response = errorHandler(err);

  return Promise.reject(response);
}

function _hideLoader(store, response) {
  store.dispatch(setLoaderStatusAction(false));

  // Intercept all requests to our domain and logout on 401.
  const requestUrl = get(response, "request.responseURL", "");
  const statusCode = get(response, "status");
  if (statusCode === 401 && requestUrl.includes(AUTH_LOGOUT_DOMAIN)) {
    const sessionExpired = Boolean(auth.getToken());
    const logoutUserAction = {
      type: USER_LOGOUT,
      payload: {
        sessionExpired,
        statusCode,
      },
    };

    store.dispatch(logoutUserAction);
  }

  return response;
}

function _showLoader(store, response) {
  store.dispatch(setLoaderStatusAction(true));

  return response;
}

/*
 * Configures xhr interception to display the loader on all xhr requests.
 */
function configureAxiosLoader(store) {
  const hideLoader = _hideLoader.bind(null, store);
  const errorHideLoader = _errorHandler.bind(null, hideLoader);
  const showLoader = _showLoader.bind(null, store);

  axios.interceptors.response.use(hideLoader, errorHideLoader);

  axios.interceptors.request.use(showLoader, errorHideLoader);
}

export { _errorHandler, _hideLoader, _showLoader, configureAxiosLoader };
